{
  "es": {
    "placeholders": {
      "name": "Nombre",
      "description": "Descripción",
      "amount": "Importe",
      "login": "Nombre de usuario o correo electrónico",
      "username": "Nombre de usuario",
      "twoFactorCode": "Código de dos factores",
      "confirmationCode": "Código de confirmación",
      "email": "Correo electrónico",
      "password": "Contraseña",
      "passwordConfirmation": "Confirmación de contraseña",
      "homepage": "Página principal",
      "discord": "Servidor de Discord",
      "youtube": "Canal de Youtube",
      "twitch": "Canal de Twitch",
      "distance": "Distancia",
      "guilded": "Servidor de Guilded",
      "color": "Color",
      "title": "Título",
      "classification": "Combate, Industrial, Multirrol...",
      "focus": "Caza ligero, Minería, Carga...",
      "minSize": "snub, pequeña, mediana...",
      "maxSize": "mediana, grande, capital...",
      "minCrew": "Tripulación mín.",
      "minCargo": "SCU",
      "modelId": "Buscar una nave",
      "scenario": "Xenothreat, Pirate Swarm, Bounty…",
      "briefing": "Briefing detallado — comunicaciones, indicativos, reglas de enfrentamiento…",
      "location": "Stanton, Pyro, ARC-L1…",
      "meetupLocation": "Daymar, Espaciopuerto — Hangar 4…",
      "maxAttendees": "Límite opcional",
      "autoLockMinutesBefore": "60",
      "timezone": "UTC",
      "startsAt": "Elige fecha y hora de inicio",
      "endsAt": "Elige fecha y hora de fin (opcional)",
      "notes": "Llevo munición extra, puedo volar de apoyo, llego en 10…",
      "signup-status": "¿Confirmada o tentativa?",
      "features": {
        "username": "Username or User ID",
        "name": "Nombre de función"
      },
      "fleetInviteToken": "Invitación de flota",
      "quicksearch": {
        "models": "Avenger, Carrack, Cutlass...",
        "hangar": "Enterprise, Andromeda..."
      },
      "search": {
        "default": "Search the Verse...",
        "roadmap-progress-tracker": "Buscar"
      },
      "home": {
        "search": "Buscar naves..."
      },
      "image": {
        "caption": "Descripción"
      },
      "model": {
        "length": "Longitud",
        "beam": "Manga",
        "height": "Altura",
        "price": "Precio",
        "pledgePrice": "Precio de Pledge",
        "onSale": "En venta",
        "mass": "Masa",
        "minCrew": "Tripulación mín.",
        "maxCrew": "Tripulación máx.",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "rsiId": "RSI ID",
        "scKey": "SC Key",
        "erkulIdentifier": "Erkul Identifier",
        "productionNote": "Nota de producción",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Velocidad máx.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "quantumFuelTankSize": "Tamaño del tanque Quantum",
        "hydrogenFuelTankSize": "Tamaño del tanque de hidrógeno",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Guiñada potenciada",
        "pitchBoosted": "Cabeceo potenciado",
        "rollBoosted": "Balanceo potenciado",
        "fleetchartOffsetLength": "Desfase de longitud del gráfico de flota",
        "fleetchartOffsetBeam": "Desfase de manga del gráfico de flota",
        "extendedLength": "Longitud extendida",
        "extendedBeam": "Manga extendida",
        "extendedHeight": "Altura extendida",
        "extendedFleetchartOffsetLength": "Desplazamiento de longitud extendida del diagrama de flota",
        "extendedFleetchartOffsetBeam": "Desplazamiento de manga extendida del diagrama de flota",
        "landedLength": "Longitud aterrizado",
        "landedBeam": "Manga aterrizado",
        "landedHeight": "Altura aterrizado",
        "landedFleetchartOffsetLength": "Desplazamiento de longitud aterrizado",
        "landedFleetchartOffsetBeam": "Desplazamiento de manga aterrizado",
        "cargo": "Carga",
        "baseModel": "Modelo base"
      },
      "cargoHold": {
        "offsetX": "Desfase X",
        "offsetY": "Desfase Y",
        "offsetZ": "Desfase Z",
        "rotation": "0 or 90"
      },
      "manufacturer": {
        "longName": "Nombre completo",
        "code": "Código",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "¿Qué ha pasado?",
        "body": "Markdown. Se muestra en la bandeja y en el correo.",
        "discordPart": "Un mensaje",
        "socialPart": "Una publicación",
        "link": "/fleets/"
      },
      "fundingGoal": {
        "title": "Costes de servidor, Dominio, Discord...",
        "description": "Contexto opcional mostrado públicamente",
        "amount": "100.00",
        "currency": "EUR",
        "effectiveFrom": "2026-01-01",
        "endedAt": "déjalo en blanco si sigue vigente"
      },
      "supporterContribution": {
        "name": "Nombre del patrocinador mostrado públicamente",
        "amount": "5.00",
        "currency": "EUR",
        "startedAt": "2026-01-01",
        "endedAt": "2026-12-31",
        "payerEmail": "donor@example.com",
        "claimKey": "FY-7K2M-9QXD",
        "note": "Nota interna opcional"
      },
      "component": {
        "componentType": "Tipo de componente",
        "componentSubType": "Subtipo de componente",
        "size": "Tamaño",
        "grade": "Grado",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "modelPaint": {
        "pledgePrice": "Precio de Pledge",
        "productionStatus": "Estado de producción",
        "productionNote": "Nota de producción"
      },
      "fleet": {
        "headquarters": "¿Dónde tiene su base la flota?",
        "fid": "ID de flota",
        "rsiSid": "RSI SID",
        "ts": "Servidor Teamspeak",
        "description": "Descripción",
        "discord": {
          "guildId": "p. ej. 123456789012345678",
          "channelId": "ID del canal de voz para el evento",
          "webhookUrl": "https://discord.com/api/webhooks/…",
          "webhookConfigured": "Guardado — déjalo vacío para mantener el actual"
        },
        "guilded": "Servidor de Guilded",
        "homepage": "Página principal",
        "twitch": "Canal de Twitch",
        "youtube": "Canal de Youtube"
      },
      "adminUser": {
        "passwordConfirmation": "Confirmación de contraseña"
      },
      "user": {
        "rsiHandle": "Handle de RSI",
        "location": "e.g. Berlin, Germany",
        "currentSystem": "p. ej. Lorville, Port Tressler, Pyro"
      },
      "oauthApplication": {
        "name": "Mi aplicación",
        "redirectUri": "https://example.com/callback",
        "scopes": "público"
      },
      "vehicle": {
        "serial": "Serial"
      },
      "itemPrice": {
        "price": "0.00",
        "location": "Ubicación",
        "locationUrl": "URL de ubicación"
      },
      "video": {
        "url": "YouTube Video ID"
      },
      "modelModule": {
        "name": "Nombre del Módulo",
        "price": "0.00",
        "pledgePrice": "0.00",
        "productionStatus": "Anunciado, Listo para Volar, En Concepto...",
        "scKey": "SC Key",
        "search": "Buscar módulos por nombre..."
      },
      "modelUpgrade": {
        "name": "Nombre de mejora",
        "pledgePrice": "0.00",
        "description": "Descripción"
      },
      "modelModulePackage": {
        "name": "Nombre del paquete",
        "pledgePrice": "0.00",
        "description": "Descripción"
      },
      "dock": {
        "name": "Nombre del muelle",
        "length": "Longitud en m",
        "beam": "Manga en m",
        "height": "Altura en m"
      },
      "modelPosition": {
        "name": "Nombre de la posición",
        "position": "0"
      },
      "logistics": {
        "inventoryName": "Main Depot, Cargo Bay...",
        "description": "Optional details about this inventory",
        "location": "e.g. Port Olisar, Area18",
        "itemName": "Titanium, Medical Supplies..."
      },
      "filters": {
        "vehicles": {
          "name": "Enterprise, Andromeda...",
          "priceLt": "Precio <=",
          "priceGt": "Precio >="
        },
        "models": {
          "name": "Gladius, Andromeda...",
          "classification": "Vehículo, Caza, Carga...",
          "manufacturer": "Origin, Robert Space Industries, Aegis...",
          "onSale": "Sí o No",
          "productionStatus": "Anunciado, Listo para volar, En concepto..."
        },
        "modelModules": {
          "name": "Bio Dome, Cargo Module..."
        },
        "manufacturers": {
          "name": "Origin, Robert Space Industries, Aegis..."
        },
        "supporterContributions": {
          "name": "Alicia, Roberto...",
          "startedAtGteq": "2026-01-01",
          "startedAtLteq": "2026-12-31"
        },
        "adminNotifications": {
          "search": "Título o contenido..."
        },
        "users": {
          "search": "Nombre de usuario o correo",
          "username": "Nombre de usuario",
          "rsiHandle": "Handle de RSI",
          "email": "Correo electrónico"
        },
        "components": {
          "name": "Nombre",
          "description": "motor cuántico, blindaje...",
          "manufacturer": "Behring, Ascension Astro, Juno Starwerk..."
        },
        "fleets": {
          "name": "Nombre",
          "fid": "FID",
          "memberCountGteq": "Mínimo de miembros",
          "memberCountLteq": "Máximo de miembros",
          "createdOnGteq": "2026-01-01",
          "createdOnLteq": "2026-12-31",
          "members": {
            "search": "Nombre de usuario o apodo"
          }
        },
        "destroyedFleets": {
          "nameOrFid": "Nombre o FID"
        },
        "commodities": {
          "name": "Agricium, Laranite, Quantainium...",
          "description": "ore, ammunition, material...",
          "uexCode": "UEX Code"
        },
        "equipment": {
          "name": "Arclight, Pembroke, Novikov..."
        },
        "notifications": {
          "search": "Título o contenido..."
        },
        "blueprints": {
          "name": "Greatsword, Testudo, Omnisky...",
          "material": "Hierro, Titanio, Aforita...",
          "craftableType": "Componente, Equipo...",
          "source": "Conocida, desconocida..."
        },
        "fleetDirectory": {
          "search": "Nombre, FID o SID...",
          "memberCountGteq": "Mínimo de miembros"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "size": "Size",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "relationships": {
        "user": {
          "handle": "Nombre de usuario de la persona"
        },
        "fleet": {
          "handle": "Identificador de la flota"
        }
      },
      "reward": "Recompensa en aUEC",
      "crewLimit": "Sin límite",
      "deadline": "Sin fecha límite",
      "itemName": "Qué entregar",
      "itemQuantity": "Cuánto",
      "itemQuality": "600"
    }
  }
}
